import Cookies from 'universal-cookie';

import requestConfig from 'Models/uiConfig/requestConfig';

const cookie = new Cookies();

const fiveYears = 5 * 365 * 24 * 60 * 60 * 1000;
const halfAnHour = 30 * 60 * 1000;

type Analytics = {
  userId: string;
  sessionId: string;
  isAnalyticsEnabled: boolean;
};

export default function getAnalytics(): Analytics {
  const { isAnalyticsEnabled } = requestConfig;
  if (isAnalyticsEnabled) {
    return {
      userId: getOrCreateCookie('cmuid', fiveYears),
      sessionId: getOrCreateCookie('cmsid', halfAnHour, { renew: true }),
      isAnalyticsEnabled,
    };
  }

  return {
    userId: '',
    sessionId: '',
    isAnalyticsEnabled,
  };
}

function getOrCreateCookie(
  name: string,
  duration: number,
  { renew = false }: { renew?: boolean } = {},
): string {
  let value = cookie.get(name);

  if ((!value && (value = generateId())) || renew) {
    const date = new Date(Date.now() + duration);
    cookie.set(name, value, { expires: date, path: '/' });
  }

  return value;
}

const idLength = 16;
const alphaNums = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
const sample = (arr: string): string => arr[Math.floor(Math.random() * arr.length)] || '';
function generateId(): string {
  for (let id = ''; ; id += sample(alphaNums)) {
    if (id.length === idLength) {
      return id;
    }
  }
}
